import React, { Component } from 'react'
import { connect } from 'react-redux'
import config from 'constants/config'
import loadScript, { scriptAlreadyLoaded } from 'lib/window/loadScript'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import { isKlarnaEnabled, isKlarnaBpEnabled } from 'lib/payment/paymentUtils'

interface Props {
  currentCurrency: string
}

class KlarnaLandingPage extends Component<React.PropsWithChildren<Props>> {
  src: string | null = null
  attrs: { 'data-client-id': string } | null = null
  dataLocale: string | null = null
  dataKey: string | null = null

  constructor(props: Props) {
    super(props)
    this.initializeScriptData(props.currentCurrency)
  }

  initializeScriptData(currency: string) {
    switch (currency) {
      case 'AUD':
        if (!config.KLARNA_CLIENT_ID_AU || !config.KLARNA_LIB_URL_OC || !isKlarnaEnabled(this.props.currentCurrency)) {
          return
        }
        this.src = config.KLARNA_LIB_URL_OC
        this.attrs = {
          'data-client-id': config.KLARNA_CLIENT_ID_AU,
        }
        this.dataLocale = 'en-AU'
        this.dataKey = 'info-page-auto-size'
        break
      case 'NZD':
        if (!config.KLARNA_CLIENT_ID_NZ || !config.KLARNA_LIB_URL_OC || !isKlarnaBpEnabled(this.props.currentCurrency)) {
          return
        }
        this.src = config.KLARNA_LIB_URL_OC
        this.attrs = {
          'data-client-id': config.KLARNA_CLIENT_ID_NZ,
        }
        this.dataLocale = 'en-NZ'
        this.dataKey = 'info-page'
        break
      case 'GBP':
        if (!config.KLARNA_CLIENT_ID_EU || !config.KLARNA_LIB_URL_EU || !isKlarnaBpEnabled(this.props.currentCurrency)) {
          return
        }
        this.src = config.KLARNA_LIB_URL_EU
        this.attrs = {
          'data-client-id': config.KLARNA_CLIENT_ID_EU,
        }
        this.dataLocale = 'en-GB'
        this.dataKey = 'info-page'
        break
      case 'USD':
        if (!config.KLARNA_CLIENT_ID_NA || !config.KLARNA_LIB_URL_NA || !isKlarnaBpEnabled(this.props.currentCurrency)) {
          return
        }
        this.src = config.KLARNA_LIB_URL_NA
        this.attrs = {
          'data-client-id': config.KLARNA_CLIENT_ID_NA,
        }
        this.dataLocale = 'en-US'
        this.dataKey = 'info-page'
        break
      default:
        break
    }
  }

  componentDidMount() {
    if (!this.src || !this.attrs) {
      return
    }
    // @ts-ignore
    if (scriptAlreadyLoaded(this.src, this.attrs)) {
      window.KlarnaOnsiteService ??= []
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
    } else {
    // @ts-ignore
      loadScript(this.src, this.attrs)
    }
  }

  render() {
    if (!this.src || !this.attrs || !this.dataKey || !this.dataLocale) {
      return <Error404PageWithOffers />
    }
    return (
    // @ts-ignore
      <klarna-placement data-key={this.dataKey} data-locale={this.dataLocale} />
    )
  }
}

const mapStateToProps = (state: App.State) => ({
  currentCurrency: state.geo.currentCurrency,
})

export default connect(mapStateToProps)(KlarnaLandingPage)
